import { PortalManagementFormValues, PortalConfig } from '../types';
import { PortalConfiguration } from 'modules/portalConfigurations/types';

export const getConfigToSave = (
  portalConfiguration: PortalConfiguration<PortalConfig>,
  formData: PortalManagementFormValues
): PortalConfiguration<PortalConfig> => {
  const config: PortalConfig = {
    allowLMS: formData.allowLMS,
    allowSyndication: formData.allowSyndication,
    enhancedStagesFlow: formData.enhancedStagesFlow,
  };

  return {
    ...portalConfiguration,
    jsonDefinition: { config },
  };
};
